import React, { useEffect, useState } from 'react';
import * as _ from 'lodash';

export default function Checklist(props) {
  const [points, setPoints] = useState(props.points);
  useEffect(() => {
    document.getElementsByName(props.pointsFieldName)[0].value = JSON.stringify(points);
  }, [points]);
  return (<div>
    <table className="form-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Punkty obowiązkowej kontroli</th>
          <th>OK</th>
          <th>NOK</th>
          <th style={{ minWidth: '150px' }}>Uwagi</th>
        </tr>
      </thead>
      <tbody>
        {_.map(points, (point, i) => (
          <tr>
            <td>{i + 1}</td>
            <td>{point.label}</td>
            <td onClick={() => {

            }}>
              <div className="switch">
                <input className="switch-input"
                       type="radio"
                       id={`checklist-point-ok-${i}`}
                       name={`checklist-point-${i}`}
                       checked={point.status === 'OK'}
                       onChange={e => {
                         let newPoints = Object.assign([], points);
                         newPoints[i]['status'] = e.currentTarget.checked ? 'OK' : 'NOK';
                         setPoints(newPoints);
                       }} />
                <label className="switch-paddle" for={`checklist-point-ok-${i}`}>
                  <span className="show-for-sr">OK</span>
                </label>
              </div>
            </td>
            <td>
              <div className="switch">
                <input className="switch-input"
                       type="radio"
                       id={`checklist-point-nok-${i}`}
                       name={`checklist-point-${i}`}
                       checked={point.status === 'NOK'}
                       onChange={e => {
                         let newPoints = Object.assign([], points);
                         newPoints[i]['status'] = e.currentTarget.checked ? 'NOK' : 'OK';
                         setPoints(newPoints);
                       }} />
                <label className="switch-paddle" htmlFor={`checklist-point-nok-${i}`}>
                  <span className="show-for-sr">NOK</span>
                </label>
              </div>
            </td>
            <td><input type="text"
                       value={point.remarks}
                       onChange={e => {
                         let newPoints = Object.assign([], points);
                         newPoints[i]['remarks'] = e.currentTarget.value;
                         setPoints(newPoints);
                       }} /></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>);
}
